export class BookingTag {
  static THEME_OTHER_PREFIX = "THEME:OTHER";

  constructor() {
    this.tag = undefined;
    this.translations = [];
    this.isFreeText = false;
  }

  isThemeTag() {
    return this.tag.indexOf("THEME:") >= 0;
  }

  isBookingTypeTag() {
    return this.tag.indexOf("BOOKING_TYPE:") >= 0;
  }

  getTranslation(lang) {
    if(!lang) {
      lang = "EN";
    }

    if(this.translations) {
      const bookingTagTranslation = this.translations.find(
        (t) => t.languageCode === lang
      );
      if(bookingTagTranslation) return bookingTagTranslation.translation;
    }
    return this.tag;
  }

  static fromJSON(json) {
    if(!json) return undefined;

    const bookingTag =  Object.assign(new BookingTag(), json);
    if(bookingTag.translations) {
      bookingTag.translations = bookingTag.translations.map(m => {
        return BookingTagTranslation.fromJSON(m);
      });
    }
    return bookingTag;
  }
}

export class BookingTagTranslation {
  constructor() {
    this.languageCode = undefined;
    this.translation = undefined;
  }

  static fromJSON(json) {
    if(!json) return undefined;

    const bookingTagTranslation =  Object.assign(new BookingTagTranslation(), json);
    return bookingTagTranslation;
  }
}
